exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".book-1{fill:none}.book-2{fill:#93e0da;isolation:isolate}.book-4{fill:#e6e6e6}.book-5{fill:#fee952}\n", ""]);
